export default __webpack_public_path__ + "static/media/AdSpace_03.84b35a81.png";